function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 24)
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)

      var date = new Date()
      date.setHours(hours)
      date.setMinutes(minutes)
      date.setSeconds(seconds)

      return date.getTime()
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    // 初始化
    alignmentFns.initialize()

  // 数字框
    let prods = window.product
function getCur(){
  let color = $('#color div.active').attr('data-val')
  let Style = $('#Style div.active').attr('data-val')
  let Size = $('#Size div.active').attr('data-val')
  return prods.filter(item=> item.option1 == color && item.option2 == Style && item.option3 == Size)[0]
}
function changePrice(){
  let num = $('#calcNumber').val()
  let price = (getCur().price  / 100).toFixed(2)
  let compare = (getCur().compare_at_price  / 100).toFixed(2)
  // price = (price + '').replace('.', ',')
  // compare = (compare + '').replace('.', ',')
  $('#new').html(price)
  $('#old').html(compare)
    let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
  $(".product-part .sp-free em").html(`${off_font}%`)
}
$('.buyNow').click(function(){
  let num = $('#calcNumber').val()
  window.location.href = '/cart/' + getCur().id + ':' + num
})
       $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
      }
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
    })


    
    $('.opt-group .option').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      changePrice()
    })
    $('#color .option').click(function () {
      var index = $(this).index()
      var index2 = $('#Style .option.active').index()
      var index3 = $('#Size .option.active').index()
      chageOption(index, index2, index3)
    })
    $('#Style .option').click(function () {
      var index = $('#color .option.active').index()
      var index2 = $(this).index()
      var index3 = $('#Size .option.active').index()
      chageOption(index, index2, index3)
    })
    $('#Size .option').click(function () {
      var index = $('#color .option.active').index()
      var index2 = $('#Style .option.active').index()
      var index3 = $(this).index()
      chageOption(index, index2, index3)
    })
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-0-0-0.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-1-0-0.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-2-0-0.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-0-1-0.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-1-1-0.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-2-1-0.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-0-0-1.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-1-0-1.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-2-0-1.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-0-0-2.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-1-0-2.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-2-0-2.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-0-1-1.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-1-1-1.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-2-1-1.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-0-1-2.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-1-1-2.webp',
      'https://cdn.shopify.com/s/files/1/0756/1596/1370/files/20241122-2-1-2.webp',
    ]
    function chageOption(index, index2, index3) {
      var index4 = 0
      if (index2 == 0 && index3 == 0) {
        index4 = index
      } else if (index2 == 1 && index3 == 0) {
        index4 = index + 3
      } else if (index2 == 0 && index3 == 1) {
        index4 = index + 3 * 2
      } else if (index2 == 0 && index3 == 2) {
        index4 = index + 3 * 3
      } else if (index2 == 1 && index3 == 1) {
        index4 = index + 3 * 4
      } else if (index2 == 1 && index3 == 2) {
        index4 = index + 3 * 5
      }
      $('.top-product img').attr('src', imgArr[index4])
    }
    addCart()
    function addCart() {
      // 加入购物车
         $('#addCart').click(function () {
       var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
        });
      },
      dataType: "json",
    });
        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 117,
            left: finish[0].offsetLeft + finish.width() / 2 + 5,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
